/* SpookyGlow theme script. No dependencies. */
(function () {
  'use strict';
  var S = window.SG || { routes: {}, strings: {}, locale: 'en', freeShipping: 0 };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var currency = null;

  function money(cents) {
    var cur = currency || (document.documentElement.getAttribute('data-currency')) || 'EUR';
    try {
      return new Intl.NumberFormat(S.locale || undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    try { var u = new URL(url, location.href); u.searchParams.set('width', w); return u.toString(); }
    catch (e) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  }
  var fine = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  function burst(el) {
    if (reduceMotion || !el) return;
    var r = el.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var icons = ['🎃', '👻', '🦇', '✨', '🕸️'];
    for (var i = 0; i < 7; i++) {
      var n = document.createElement('span');
      n.className = 'burst'; n.textContent = icons[i % icons.length];
      var ang = (Math.PI * 2) * (i / 7) - Math.PI / 2 + (Math.random() - 0.5) * 0.6, dist = 46 + Math.random() * 44;
      n.style.left = cx + 'px'; n.style.top = cy + 'px';
      n.style.setProperty('--dx', Math.cos(ang) * dist + 'px'); n.style.setProperty('--dy', Math.sin(ang) * dist + 'px');
      document.body.appendChild(n);
      (function (x) { setTimeout(function () { if (x.parentNode) x.parentNode.removeChild(x); }, 900); })(n);
    }
  }
  /* Quantity offers, e.g. "3:33.3333,4:25" → 3+ items 33.33% off (2+1 free), 4+ items 25% off (3+1 free) */
  var TIERS = String(S.tiers || '').split(',').map(function (t) {
    var p = t.split(':'); return { qty: parseInt(p[0], 10), pct: parseFloat(p[1]) };
  }).filter(function (t) { return t.qty > 0 && t.pct > 0 && t.pct < 100; }).sort(function (a, b) { return a.qty - b.qty; });
  function tierFor(qty) { var best = null; TIERS.forEach(function (t) { if (qty >= t.qty) best = t; }); return best; }
  function offerName(t) { return t ? (t.qty - 1) + '+1 free' : ''; }
  function discounted(total, qty) { var t = tierFor(qty); return t ? Math.round(total * (1 - t.pct / 100)) : total; }

  function toast(msg) {
    var t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2400);
  }
  function json(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) { var err = new Error(d.description || d.message || 'error'); err.data = d; throw err; }
        return d;
      });
    });
  }

  /* ---------- Cart ---------- */
  var drawer, scrim, lastFocus;
  function getCart() { return json(S.routes.cartJson + '?t=' + Date.now()); }

  function updateCount(cart) {
    currency = cart.currency || currency;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function shipHtml(cart) {
    if (!S.freeShipping) return '';
    var left = S.freeShipping - cart.total_price;
    var pct = Math.max(0, Math.min(100, (cart.total_price / S.freeShipping) * 100));
    var msg = left > 0 ? S.strings.freeAway.replace('{amount}', '<strong>' + money(left) + '</strong>') : '<strong>' + S.strings.freeDone + '</strong>';
    return '<div>' + msg + '</div><div class="ship-bar"><i style="width:' + pct + '%"></i></div>';
  }

  function lineHtml(item, i) {
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="line-var">' + esc(item.variant_title) + '</div>' : '';
    var was = item.original_line_price > item.final_line_price ? '<s>' + money(item.original_line_price) + '</s>' : '';
    return '<div class="line" data-line="' + (i + 1) + '">' +
      '<a href="' + esc(item.url) + '">' + (item.image ? '<img src="' + esc(sized(item.image, 160)) + '" alt="' + esc(item.featured_image && item.featured_image.alt || item.product_title) + '" width="76" height="76" loading="lazy">' : '<span></span>') + '</a>' +
      '<div><a class="line-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant +
      '<div class="line-tools"><div class="qty">' +
      '<button type="button" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">' + icon('minus') + '</button>' +
      '<input type="number" value="' + item.quantity + '" min="0" aria-label="Quantity" data-qty-input>' +
      '<button type="button" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">' + icon('plus') + '</button></div>' +
      '<button type="button" class="line-remove" data-qty="0">' + S.strings.remove + '</button></div></div>' +
      '<div class="line-price">' + was + money(item.final_line_price) + '</div></div>';
  }
  function icon(name) {
    var p = { plus: '<path d="M12 5v14M5 12h14"/>', minus: '<path d="M5 12h14"/>' }[name] || '';
    return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true">' + p + '</svg>';
  }

  function upsellHtml(cart) {
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.variant_id] = true; });
    var pool = (S.monsters || []).filter(function (m) { return m.available && !inCart[m.id]; });
    if (!pool.length) return '';
    var start = (cart.item_count * 2) % pool.length, picks = [];
    for (var i = 0; i < Math.min(3, pool.length); i++) picks.push(pool[(start + i) % pool.length]);
    return '<div class="upsell"><h3>Complete your squad</h3>' + picks.map(function (m) {
      return '<div class="up"><img src="' + esc(sized(m.image, 120)) + '" alt="" width="52" height="52" loading="lazy"><div><strong>' + esc(m.title) + '</strong><span>' + money(m.price) + '</span></div>' +
        '<button type="button" class="btn btn-small" data-add="' + m.id + '">Add</button></div>';
    }).join('') + '</div>';
  }

  function renderCart(cart) {
    updateCount(cart);
    if (!drawer) return;
    var body = $('[data-cart-items]', drawer), foot = $('[data-cart-foot]', drawer), ship = $('[data-cart-ship]', drawer);
    if (!cart.item_count) {
      body.innerHTML = '<div class="drawer-empty"><p>' + S.strings.empty + '</p><a class="btn btn-primary" href="/collections/all" data-drawer-close>Browse monsters</a></div>';
      foot.hidden = true; ship.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(lineHtml).join('') + upsellHtml(cart);
    $('[data-cart-subtotal]', drawer).textContent = money(cart.total_price);
    var extra = '';
    var saved = cart.original_total_price - cart.total_price;
    if (saved > 0) extra += '<div class="drawer-save"><span>' + S.strings.youSave + '</span><span>' + money(saved) + '</span></div>';
    var next = TIERS.filter(function (t) { return t.qty > cart.item_count; })[0];
    if (next) extra += '<p class="nudge">' + esc(S.strings.nudge.replace('{n}', next.qty - cart.item_count).replace('{offer}', offerName(next))) + '</p>';
    var slot = $('[data-cart-extra]', drawer); if (slot) slot.innerHTML = extra;
    foot.hidden = false;
    var sh = shipHtml(cart);
    ship.innerHTML = sh; ship.hidden = !sh;
  }

  function openDrawer() {
    if (!drawer) { location.href = S.routes.cart; return; }
    if (drawer.classList.contains('is-open')) { getCart().then(renderCart).catch(function () {}); return; }
    lastFocus = document.activeElement;
    scrim.hidden = false;
    requestAnimationFrame(function () {
      scrim.classList.add('is-open');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      drawer.focus({ preventScroll: true });
    });
    getCart().then(renderCart).catch(function () { toast(S.strings.error); });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    setTimeout(function () { scrim.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function addToCart(items) {
    return json(S.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () { return getCart(); }).then(function (cart) { renderCart(cart); return cart; });
  }
  function changeLine(line, qty) {
    return json(S.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    drawer = $('#CartDrawer'); scrim = $('.drawer-scrim');
    getCart().then(updateCount).catch(function () {});
  });

  /* Global click handling */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var openBtn = t.closest('[data-cart-open]');
    if (openBtn && drawer && !(e.metaKey || e.ctrlKey)) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-drawer-close]')) { closeDrawer(); return; }

    var add = t.closest('[data-add]');
    if (add) {
      e.preventDefault();
      var label = add.textContent;
      add.classList.add('is-loading');
      addToCart([{ id: Number(add.getAttribute('data-add')), quantity: 1 }]).then(function () {
        add.classList.remove('is-loading'); add.classList.add('is-done'); add.textContent = S.strings.added; burst(add);
        setTimeout(function () { add.classList.remove('is-done'); add.textContent = label; }, 1600);
        openDrawer();
      }).catch(function (err) {
        add.classList.remove('is-loading');
        toast(err.message || S.strings.error);
      });
      return;
    }

    var q = t.closest('[data-qty]');
    if (q) {
      var row = q.closest('[data-line]');
      if (!row) return;
      var qty = Number(q.getAttribute('data-qty'));
      var inDrawer = !!q.closest('#CartDrawer');
      row.style.opacity = '.5';
      changeLine(Number(row.getAttribute('data-line')), Math.max(0, qty)).then(function (cart) {
        if (inDrawer) renderCart(cart); else location.reload();
      }).catch(function (err) { row.style.opacity = ''; toast(err.message || S.strings.error); });
      return;
    }

    var stepper = t.closest('[data-step]');
    if (stepper) {
      var input = $('input', stepper.closest('.qty'));
      var min = Number(input.min || 1);
      input.value = Math.max(min, (Number(input.value) || min) + Number(stepper.getAttribute('data-step')));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-qty-input]');
    if (inp) {
      var row = inp.closest('[data-line]');
      changeLine(Number(row.getAttribute('data-line')), Math.max(0, Number(inp.value) || 0)).then(function (cart) {
        if (inp.closest('#CartDrawer')) renderCart(cart); else location.reload();
      }).catch(function (err) { toast(err.message || S.strings.error); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeNav(); } });

  /* ---------- Mobile nav ---------- */
  function closeNav() {
    var m = $('.mobile-nav'), b = $('.nav-toggle');
    if (m && m.classList.contains('is-open')) { m.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.nav-toggle');
    if (!b) return;
    var m = $('.mobile-nav'); var open = m.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Product form ---------- */
  function initProduct(root) {
    var form = $('[data-product-form]', root);
    if (!form) return;
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', root).textContent); } catch (e) {}
    var idInput = $('[name=id]', form), qtyInput = $('[name=quantity]', form);
    var priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root), saveEl = $('[data-save]', root);
    var btn = $('[data-submit]', form), btnLabel = $('[data-submit-label]', form), msg = $('[data-msg]', form);
    var mainImg = $('[data-main-img]', root), thumbs = $$('[data-thumb]', root);
    var bar = $('[data-buybar]', root), barPrice = $('[data-bar-price]', root);
    var optNames = $$('[data-option]', form);
    var current = null;

    function byId(id) { return variants.filter(function (v) { return v.id === Number(id); })[0]; }
    root._has = function (id) { return !!byId(id); };
    root._avail = function (map) {
      variants.forEach(function (v) { if (map.hasOwnProperty(v.id)) v.available = map[v.id]; });
      if (current && !current.available) {
        var alt = variants.filter(function (v) { return v.available; })[0];
        if (alt) { root.dispatchEvent(new CustomEvent('sg:select', { detail: { id: alt.id } })); return; }
      }
      sync();
    };
    function selectedOptions() {
      var out = [];
      $$('[data-option]', form).forEach(function (fs) {
        var c = $('input:checked', fs); out[Number(fs.getAttribute('data-option'))] = c ? c.value : null;
      });
      return out;
    }
    function find(opts) {
      return variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] === o; }); })[0];
    }
    function showImage(src) {
      if (!src || !mainImg) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-src') === src ? 'true' : 'false'); });
    }
    function total() { return current ? current.price * (Number(qtyInput.value) || 1) : 0; }
    function paint() {
      if (!current) { btn.disabled = true; btnLabel.textContent = 'Unavailable'; return; }
      idInput.value = current.id;
      priceEl.textContent = money(current.price);
      var onSale = current.compare > current.price;
      if (compareEl) { compareEl.hidden = !onSale; compareEl.textContent = onSale ? money(current.compare) : ''; }
      if (saveEl) { saveEl.hidden = !onSale; saveEl.textContent = onSale ? 'Save ' + Math.round((1 - current.price / current.compare) * 100) + '%' : ''; }
      btn.disabled = !current.available;
      var q = Number(qtyInput.value) || 1, full = total(), pay = discounted(full, q);
      if (!current.available) btnLabel.textContent = S.strings.soldOut;
      else btnLabel.innerHTML = esc(S.strings.add) + ' · ' + money(pay) + (pay < full ? '<s>' + money(full) + '</s>' : '');
      $$('[data-pack-price]', root).forEach(function (el) {
        var n = Number(el.getAttribute('data-pack-price')), f = current.price * n, d = discounted(f, n);
        el.innerHTML = (d < f ? '<s>' + money(f) + '</s>' : '') + money(d);
      });
      $$('[data-buy-now]', form).forEach(function (b) { b.disabled = !current.available; });
      if (barPrice) barPrice.textContent = money(current.price);
      if (current.title && current.title !== 'Default Title') $$('[data-selected-label]', root).forEach(function (l) { l.textContent = current.title; });
      if (current.image) showImage(current.image);
      var u = new URL(location.href); u.searchParams.set('variant', current.id);
      if (!location.pathname.match(/^\/$/)) history.replaceState({}, '', u);
    }
    function sync() {
      var v = find(selectedOptions());
      current = v || null; paint();
    }
    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option]')) sync();
      if (e.target.name === 'quantity') paint();
      var pack = e.target.closest('[data-pack]');
      if (pack) { qtyInput.value = pack.querySelector('input').value; paint(); }
    });
    root.addEventListener('sg:select', function (e) {
      var v = byId(e.detail.id); if (!v) return;
      v.options.forEach(function (val, i) {
        var fs = $('[data-option="' + i + '"]', form); if (!fs) return;
        $$('input', fs).forEach(function (inp) { inp.checked = inp.value === val; });
      });
      sync();
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showImage(t.getAttribute('data-src')); });
    });

    form.addEventListener('submit', function (e) {
      if (!current || !current.available) { e.preventDefault(); return; }
      var buyNow = e.submitter && e.submitter.hasAttribute('data-buy-now');
      e.preventDefault();
      msg.textContent = '';
      btn.classList.add('is-loading');
      addToCart([{ id: current.id, quantity: Number(qtyInput.value) || 1 }]).then(function () {
        btn.classList.remove('is-loading');
        if (buyNow) { location.href = '/checkout'; return; }
        btn.classList.add('is-done'); btnLabel.textContent = S.strings.added; burst(btn);
        setTimeout(function () { btn.classList.remove('is-done'); paint(); }, 1500);
        openDrawer();
      }).catch(function (err) {
        btn.classList.remove('is-loading');
        msg.textContent = err.message || S.strings.error;
      });
    });

    /* initial state from ?variant= */
    var wanted = new URL(location.href).searchParams.get('variant');
    if (wanted && byId(wanted)) root.dispatchEvent(new CustomEvent('sg:select', { detail: { id: wanted } }));
    else sync();

    /* mobile buy bar: show once the buy box is out of view */
    if (bar && 'IntersectionObserver' in window) {
      var target = $('[data-submit]', form);
      new IntersectionObserver(function (en) {
        var visible = en[0].isIntersecting;
        var above = en[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-on', !visible && above);
      }).observe(target);
    }
  }

  /* ---------- Characters grid ---------- */
  function initCharacters(root) {
    var chips = $$('[data-filter]', root), items = $$('[data-family]', root);
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.getAttribute('data-filter');
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        items.forEach(function (it) { it.hidden = !(f === 'all' || it.getAttribute('data-family') === f); });
      });
    });
    root.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-pick]');
      if (!pick) return;
      var buy = document.getElementById('buy');
      if (!buy || !buy._has || !buy._has(pick.getAttribute('data-pick'))) return; /* follow the link instead */
      e.preventDefault();
      buy.dispatchEvent(new CustomEvent('sg:select', { detail: { id: pick.getAttribute('data-pick') } }));
      buy.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------- Flashlight: hero stage and whole grids ---------- */
  function initStage(stage) {
    var dark = $('.stage-dark', stage);
    if (!dark) return;
    var sw = $('[data-lights]', stage) || $('[data-lights]', stage.closest('section') || document);
    var isGrid = stage.hasAttribute('data-grid-stage');
    var radius = isGrid ? 290 : (fine ? 190 : 250);
    dark.style.setProperty('--a', isGrid ? (fine ? '.82' : '.5') : (fine ? '.86' : '.62'));
    var pos = null, target = null, raf = null, lit = false;

    function box() { return stage.getBoundingClientRect(); }
    function home() {
      var r = box();
      return isGrid ? { x: r.left + r.width * 0.5, y: Math.min(r.top + 220, window.innerHeight * 0.5) } : { x: r.left + r.width * 0.62, y: r.top + r.height * 0.4 };
    }
    function paint() {
      if (!pos) return;
      var r = box();
      dark.style.setProperty('--mx', (pos.x - r.left) + 'px');
      dark.style.setProperty('--my', (pos.y - r.top) + 'px');
    }
    function loop() {
      pos.x += (target.x - pos.x) * 0.18; pos.y += (target.y - pos.y) * 0.18;
      paint();
      raf = (Math.abs(target.x - pos.x) > 0.6 || Math.abs(target.y - pos.y) > 0.6) ? requestAnimationFrame(loop) : null;
    }
    function move(e) {
      if (lit) return;
      target = { x: e.clientX, y: e.clientY };
      if (reduceMotion) { pos = { x: target.x, y: target.y }; paint(); } else if (!raf) raf = requestAnimationFrame(loop);
    }
    function setLit(v) {
      lit = v;
      stage.classList.toggle('is-lit', v);
      if (sw) {
        sw.setAttribute('aria-pressed', v ? 'true' : 'false');
        sw.textContent = v ? (sw.getAttribute('data-off') || 'Lights off') : (sw.getAttribute('data-on') || 'Lights on');
      }
    }
    function setRadius(px) { dark.style.setProperty('--r', px + 'px'); }
    function flicker() {
      var seq = reduceMotion ? [radius] : [0, 70, 10, 120, 0, 90, radius], i = 0;
      (function step() { setRadius(seq[i]); i++; if (i < seq.length) setTimeout(step, i < 6 ? 110 : 160); })();
    }

    pos = home(); target = { x: pos.x, y: pos.y };
    paint();
    stage.addEventListener('pointermove', move);
    stage.addEventListener('pointerdown', move);
    window.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', function () { if (!lit) { pos = home(); target = { x: pos.x, y: pos.y }; } paint(); });
    if (sw) sw.addEventListener('click', function () { setLit(!lit); });

    var startLit = stage.getAttribute('data-default') === 'lit' || (isGrid && !fine);
    if (startLit) { setRadius(radius); setLit(true); }
    else { setLit(false); if (isGrid) setRadius(radius); else { setRadius(0); flicker(); } }
    stage._sg = { flicker: flicker };
  }

  /* ---------- Hero: quick switcher ---------- */
  function initHero(root) {
    var list = (S.monsters || []).slice(0, Number(root.getAttribute('data-picks')) || 0);
    var picks = $('[data-hero-picks]', root);
    if (!picks || !list.length) return;
    var stage = $('.stage', root), img = $('.stage img', root);
    var nameEl = $('[data-hero-name]', root), priceEl = $('[data-hero-price]', root), cmpEl = $('[data-hero-compare]', root), addBtn = $('[data-hero-add]', root);
    picks.innerHTML = list.map(function (m, i) {
      return '<button type="button" class="hp" data-hp="' + i + '" aria-pressed="' + (i === 0 ? 'true' : 'false') + '" aria-label="' + esc(m.title) + '"><img src="' + esc(sized(m.image, 140)) + '" alt="" width="58" height="58" loading="lazy"></button>';
    }).join('');
    function select(i) {
      var m = list[i];
      $$('.hp', picks).forEach(function (b, j) { b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = sized(m.image, 1400); img.alt = m.title; }
      if (nameEl) nameEl.textContent = m.title;
      if (priceEl) priceEl.textContent = money(m.price);
      if (cmpEl) { var sale = m.compare > m.price; cmpEl.hidden = !sale; cmpEl.textContent = sale ? money(m.compare) : ''; }
      if (addBtn) { addBtn.setAttribute('data-add', m.id); addBtn.disabled = !m.available; addBtn.textContent = m.available ? S.strings.add : S.strings.soldOut; }
      if (stage && stage._sg) stage._sg.flicker();
    }
    picks.addEventListener('click', function (e) {
      var b = e.target.closest('.hp');
      if (b) select(Number(b.getAttribute('data-hp')));
    });
  }

  /* ---------- Catalog: filters, sort, squad tray ---------- */
  function initCatalog(root) {
    var grid = $('[data-grid]', root);
    if (!grid) return;
    var cards = $$('.char', grid);
    var tray = $('[data-tray]', root), thumbs = $('[data-tray-thumbs]', root), countEl = $('[data-tray-count]', root), totalEl = $('[data-tray-total]', root);
    var countOut = $('[data-cat-count]', root), emptyEl = $('[data-cat-empty]', root), filterBox = $('[data-cat-filters]', root);
    var byId = {};
    (S.monsters || []).forEach(function (m) { byId[m.id] = m; });
    var state = { type: [], size: [], color: [], q: '', sort: 'featured' };
    var sel = [];
    try { sel = JSON.parse(sessionStorage.getItem('sg-squad') || '[]'); } catch (e) { sel = []; }
    sel = sel.filter(function (id) { return byId[id] && byId[id].available; });

    function save() { try { sessionStorage.setItem('sg-squad', JSON.stringify(sel)); } catch (e) {} }
    function matches(c) {
      var d = c.dataset;
      if (state.type.length && state.type.indexOf(d.family) < 0) return false;
      if (state.size.length && state.size.indexOf(d.size) < 0) return false;
      if (state.color.length && state.color.indexOf(d.color) < 0) return false;
      if (state.q && d.name.toLowerCase().indexOf(state.q) < 0) return false;
      return true;
    }
    function apply() {
      var n = 0;
      cards.forEach(function (c) { var ok = matches(c); c.hidden = !ok; if (ok) n++; });
      if (countOut) countOut.textContent = n + (n === 1 ? ' monster' : ' monsters');
      if (emptyEl) emptyEl.hidden = n > 0;
    }
    function order() {
      var arr = cards.slice();
      arr.sort(function (a, b) {
        var da = a.dataset, db = b.dataset;
        if (state.sort === 'name') return da.name.localeCompare(db.name);
        if (state.sort === 'color') return da.color.localeCompare(db.color) || da.name.localeCompare(db.name);
        if (state.sort === 'size') return (da.size === 'one' ? 99 : parseFloat(da.size)) - (db.size === 'one' ? 99 : parseFloat(db.size)) || Number(da.index) - Number(db.index);
        return Number(da.index) - Number(db.index);
      });
      arr.forEach(function (c) { grid.appendChild(c); });
    }
    function paintSel() {
      cards.forEach(function (c) {
        var on = sel.indexOf(Number(c.dataset.id)) > -1;
        c.classList.toggle('is-picked', on);
        var b = $('.char-pick', c); if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var total = 0;
      sel.forEach(function (id) { total += byId[id].price; });
      thumbs.innerHTML = sel.slice(-5).map(function (id) {
        return '<img src="' + esc(sized(byId[id].image, 100)) + '" alt="' + esc(byId[id].title) + '" width="44" height="44">';
      }).join('') + (sel.length > 5 ? '<span class="more">+' + (sel.length - 5) + '</span>' : '');
      var t = tierFor(sel.length), pay = discounted(total, sel.length);
      countEl.textContent = sel.length + (sel.length === 1 ? ' monster' : ' monsters') + (t ? ' · ' + offerName(t) : '');
      totalEl.innerHTML = (pay < total ? '<s>' + money(total) + '</s>' : '') + money(pay);
      tray.hidden = sel.length === 0;
    }
    function toggle(id, force) {
      var i = sel.indexOf(id);
      if (force === true && i < 0) sel.push(id);
      else if (force === false && i > -1) sel.splice(i, 1);
      else if (force === undefined) { if (i > -1) sel.splice(i, 1); else sel.push(id); }
      save(); paintSel();
    }
    function resetFilters() {
      state.type = []; state.size = []; state.color = []; state.q = '';
      $$('input[data-group]', root).forEach(function (i) { i.checked = false; });
      var q = $('[data-cat-search]', root); if (q) q.value = '';
      apply();
    }

    grid.addEventListener('click', function (e) {
      var b = e.target.closest('.char-pick');
      if (!b || b.disabled) return;
      toggle(Number(b.closest('.char').dataset.id));
    });
    if (filterBox) filterBox.addEventListener('change', function (e) {
      var g = e.target.getAttribute('data-group');
      if (!g) return;
      state[g] = $$('input[data-group="' + g + '"]:checked', filterBox).map(function (i) { return i.value; });
      apply();
    });
    var search = $('[data-cat-search]', root);
    if (search) search.addEventListener('input', function () { state.q = search.value.trim().toLowerCase(); apply(); });
    var sortSel = $('[data-cat-sort]', root);
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; order(); });
    $$('[data-cat-reset]', root).forEach(function (b) { b.addEventListener('click', resetFilters); });
    var ft = $('[data-filters-toggle]', root);
    if (ft && filterBox) ft.addEventListener('click', function () {
      var open = filterBox.classList.toggle('is-open');
      ft.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    $('[data-tray-clear]', root).addEventListener('click', function () { sel = []; save(); paintSel(); });
    $('[data-tray-add]', root).addEventListener('click', function () {
      var btn = this;
      if (!sel.length) return;
      btn.classList.add('is-loading');
      addToCart(sel.map(function (id) { return { id: id, quantity: 1 }; })).then(function () {
        btn.classList.remove('is-loading'); burst(btn);
        sel = []; save(); paintSel(); openDrawer();
      }).catch(function (err) { btn.classList.remove('is-loading'); toast(err.message || S.strings.error); });
    });

    root._pick = function (id) {
      resetFilters();
      var c = cards.filter(function (x) { return Number(x.dataset.id) === id; })[0];
      if (!c) return;
      toggle(id, true);
      c.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      c.classList.add('is-flash');
      setTimeout(function () { c.classList.remove('is-flash'); }, 2600);
    };
    apply(); paintSel();
  }

  /* ---------- Surprise me ---------- */
  function surprise() {
    var pool = (S.monsters || []).filter(function (m) { return m.available; });
    if (!pool.length) return;
    var m = pool[Math.floor(Math.random() * pool.length)];
    var cat = $('[data-catalog]');
    if (cat && cat._pick) { cat._pick(m.id); toast('Meet ' + m.title); return; }
    var buy = document.getElementById('buy');
    if (buy && buy._has && buy._has(m.id)) {
      buy.dispatchEvent(new CustomEvent('sg:select', { detail: { id: m.id } }));
      buy.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      toast('Meet ' + m.title);
      return;
    }
    location.href = m.url;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-surprise]')) { e.preventDefault(); surprise(); }
  });

  /* ---------- Reviews summary → product rating line ---------- */
  function initRatings() {
    var sum = $('[data-review-summary]');
    $$('[data-rating-slot]').forEach(function (slot) {
      if (!sum) return;
      var avg = parseFloat(sum.getAttribute('data-avg')) || 0, n = parseInt(sum.getAttribute('data-count'), 10) || 0;
      if (!n) return;
      slot.innerHTML = '<span class="stars" style="--rating:' + avg + '" role="img" aria-label="' + avg + ' out of 5"></span> <a href="#reviews">' + avg.toFixed(1) + ' · ' + n + ' ' + (n === 1 ? S.strings.reviewsOne : S.strings.reviewsMany) + '</a>';
    });
  }

  /* ---------- Sort + filters ---------- */
  function initCollection() {
    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString();
    });
    var ff = $('[data-filter-form]');
    if (ff) ff.addEventListener('change', function () {
      var p = new URLSearchParams(new FormData(ff));
      Array.from(p.keys()).forEach(function (k) { if (p.get(k) === '') p.delete(k); });
      location.search = p.toString();
    });
  }

  /* ---------- Live availability: Shopify's storefront data is the source of truth ---------- */
  function liveAvailability() {
    if (!$('[data-vid]') && !$('[data-product]')) return;
    json('/products.json?limit=250').then(function (d) {
      var map = {}, n = 0;
      (d.products || []).forEach(function (p) {
        (p.variants || []).forEach(function (v) { map[v.id] = !!v.available; n++; });
      });
      if (!n) return;
      (S.monsters || []).forEach(function (m) { if (map.hasOwnProperty(m.id)) m.available = map[m.id]; });
      $$('[data-vid]').forEach(function (el) {
        var id = Number(el.getAttribute('data-vid'));
        if (!map.hasOwnProperty(id)) return;
        var ok = map[id];
        if (el.tagName === 'INPUT' || el.tagName === 'BUTTON') { el.disabled = !ok; return; }
        el.classList.toggle('is-soldout', !ok);
        $$('.js-ok', el).forEach(function (x) { x.hidden = !ok; });
        $$('.js-sold', el).forEach(function (x) { x.hidden = ok; });
        var pick = $('.char-pick', el); if (pick) pick.disabled = !ok;
      });
      $$('[data-product]').forEach(function (r) { if (r._avail) r._avail(map); });
    }).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    $$('[data-product]').forEach(initProduct);
    $$('[data-characters]').forEach(initCharacters);
    $$('[data-stage]').forEach(initStage);
    $$('[data-hero]').forEach(initHero);
    $$('[data-catalog]').forEach(initCatalog);
    liveAvailability();
    initRatings();
    initCollection();
  });
})();
